module.exports = __webpack_public_path__ + "static/media/5.a41237d6.png";